import React from "react";
import ProductsList from "./components/ProductsList";

function Home() {
  //write code here

  return <ProductsList />;
}

export default Home;
